// TODO: Update or remove this once the cart component is updated. It is
// used by LineItem.
export const getBogoPromotions = function getBogoPromotions(promotions) {
  const promoArray = promotions || [];

  return promoArray.filter(promo => promo.tags && promo.tags.includes('BOGO'));
};

export const getAddonPromotionForProduct = function getAddonPromotionForProduct(productId) {
  const addonPromotion = window.seMarketplace.productAddonMessage;

  return (
    addonPromotion &&
    addonPromotion.qualifyingProducts &&
    addonPromotion.qualifyingProducts[productId] &&
    addonPromotion
  );
};

export const isAddonAppliedToCart = function isAddonAppliedToCart(lineItems) {
  const addonPromotion = window.seMarketplace.productAddonMessage;

  if (
    !addonPromotion ||
    !addonPromotion.addonProducts
  ) {
    return false;
  }

  return !!lineItems.find(lineItem => !!addonPromotion.addonProducts[lineItem.id]);
};
